let isUpdatingCart = false;
const formatTodayISO = () => {
  return new Date().toISOString().slice(0, 10);
};
const updateDatesInCart = async () => {
  console.log("Checking cart for outdated order dates...");
  if (isUpdatingCart) return;
  isUpdatingCart = true;
  console.log("Updating cart order dates...");
  try {
    const cart = await fetch('/cart.js').then(r => r.json());
    const todayISO = formatTodayISO();
    const today = new Date(todayISO);
    today.setHours(0,0,0,0);
    for (const item of cart.items) {
      const rawDate = item.properties?.["Delivery Date"];
      if (!rawDate) continue;
      const itemDate = new Date(rawDate);
      itemDate.setHours(0,0,0,0);
      if (itemDate < today) {
        console.log("Fixing date for", item.title, "->", todayISO);
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: item.key,
            properties: {
              ...item.properties,
              "Delivery Date": todayISO
            }
          })
        }).then(res => {
          if (!res.ok) console.warn('change.js response not ok for', item.key, res.status);
          return res;
        }).catch(err => console.error('change.js error', err));
      }
    }
    console.log("Date fixes complete.");
  } catch (err) {
    console.error("Failed to update cart:", err);
  } finally {
    setTimeout(() => { isUpdatingCart = false; }, 500);
  }
};
document.addEventListener('DOMContentLoaded', () => {
  updateDatesInCart();
});
window.addEventListener('load', () => {
  updateDatesInCart();
});
const observeCart = () => {
  const cartIcon = document.querySelector(".header__icon--cart");
  if (!cartIcon) return;
  const mo = new MutationObserver(() => {
    updateDatesInCart();
  });
  mo.observe(cartIcon, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
  });
  updateDatesInCart();
};
const waitForCartParent = setInterval(() => {
  if (document.querySelector(".header__icon--cart")) {
    clearInterval(waitForCartParent);
    observeCart();
  }
}, 300);